const filterActivitiesById = (attachments, activityIds) => {
  return attachments?.filter((attachment) =>
    activityIds?.includes(attachment.id),
  );
};

export default filterActivitiesById;
